import { HELP_CENTER, LOGIN } from '@/common/constants/constants';
import { useEventbriteUrl } from '@/common/constants/useEventbriteUrl';
import React from 'react';
import { EBWordmark } from '../EBWordmark';
import styles from './Header.module.scss';
import { HeaderCTA } from './HeaderCTA';

export const Header: React.FunctionComponent = () => {
  const EB_HOME_URL = useEventbriteUrl('EB_HOME_URL');
  const HELP_CENTER_URL = useEventbriteUrl('HELP_CENTER_URL');
  const LOGIN_URL = useEventbriteUrl('LOGIN_URL');

  console.log(EB_HOME_URL);
  return (
    <header className={`${styles.header} flex-center-vertical`}>
      <div className={styles.branding}>
        <a href={EB_HOME_URL} aria-label="Eventbrite Home" className={styles.brand_wordmark}>
          <i>
            <EBWordmark />
            <span style={{ visibility: 'hidden' }}>Eventbrite</span>
          </i>
        </a>
        <HeaderCTA
          ctaBtnText={HELP_CENTER}
          ctaUrl={HELP_CENTER_URL}
          className={styles.brand_name}
        />
      </div>
      <div className={styles.cta}>
        <HeaderCTA ctaBtnText={LOGIN} ctaUrl={LOGIN_URL} />
      </div>
    </header>
  );
};
